import { render } from "./AllocatedAccomplished.vue?vue&type=template&id=4ed4f2a2&scoped=true"
import script from "./AllocatedAccomplished.vue?vue&type=script&lang=js"
export * from "./AllocatedAccomplished.vue?vue&type=script&lang=js"

import "./AllocatedAccomplished.vue?vue&type=style&index=0&id=4ed4f2a2&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed4f2a2"]])

export default __exports__